module.exports = __webpack_public_path__ + "img/chr_ts_26.e8274d2b.png";